import React, { Component } from "react";
import { auth, uiConfig } from "../Utils/firebase.auth";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import CGU from "../Components/CGU";
import logo from "../img/m4p.jpg";
import "../styles/login.css";

export default class Login extends Component {
  state = { isCGUopen: false };

  render() {
    this.props.location.state
      ? (uiConfig.signInSuccessUrl = this.props.location.state.from.pathname)
      : (uiConfig.signInSuccessUrl = "/")
    ;

    return (
      <div style={{ marginTop: "150px" }}>
        <img src={logo} alt="logo" width="150" />
        <h1>Connectez vous !</h1>

        {/* <h3 style={{color: '#A00E0E'}}>IMPORTANT : Only authorized users accepted on this platform.</h3> */}

        <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={auth} />

        <p style={{ fontSize: ".8rem" }}>
          En vous connectant, vous acceptez les{" "}
          <span
            style={{ color: "blue", cursor: "pointer" }}
            onClick={() => this.setState({ isCGUopen: true })}
          >
            Conditions Générales d'Utilisation
          </span>
        </p>
        
        {this.state.isCGUopen && <CGU />}
      </div>
    );
  }
}
